<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
    <path
      d="M0 11.415c.042-.102.135-1.016.173-1.215.223-1.177.632-2.31 1.21-3.36A11.023 11.023 0 0 1 7.97 1.583C14.4-.29 20.96 4.069 21.9 10.653c.031.223.034.538.1.744v1.675c-.044.131-.065.418-.082.565-.028.241-.064.48-.107.72-.171.935-.595 2.125-1.042 2.976-.552 1.049-1.88 3.055-3.038 3.425-1.357.433-2.081-.501-3.133-1.05a7.9 7.9 0 0 0-7.87.373c-.384.248-.702.53-1.145.667a2.212 2.212 0 0 1-1.681-.16c-.401-.212-.766-.605-1.07-.945a11.032 11.032 0 0 1-2.496-4.641c-.092-.36-.155-.718-.22-1.084-.044-.25-.039-.636-.116-.863v-1.64zm11.312 6.307a5.58 5.58 0 1 0-.68-11.137 5.58 5.58 0 0 0 .68 11.137z"
      fill="#62D84E" />
  </svg>
</template>
<script setup lang="ts">
defineOptions({
  name: 'mark-product-service-now'
})
</script>
